import { Alert } from '@mui/lab';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import FormatSizeOutlinedIcon from '@mui/icons-material/FormatSizeOutlined';
import { useTranslation } from 'react-i18next';
import { employeeFormMap } from '../../../../translations';

const fieldIcon = field => {
  let iconNode;
  switch (field) {
    case 'email':
      iconNode = <MailOutlineOutlinedIcon />;
      break;
    case 'firstName':
    case 'lastName':
      iconNode = <FormatSizeOutlinedIcon />;
      break;
    case 'iban':
      iconNode = <CreditCardRoundedIcon />;
      break;
    case 'personalId':
      iconNode = <PersonOutlineOutlinedIcon />;
      break;
    case 'phone':
      iconNode = <PhoneIphoneRoundedIcon />;
      break;
    case 'salary':
      iconNode = <EuroOutlinedIcon />;
      break;
    default:
      iconNode = <PersonOutlineOutlinedIcon />;
      break;
  }

  return iconNode;
};

const useStyles = makeStyles(theme => ({
  alert: {
    padding: `12px ${theme.spacing(2)}`,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  icon: {
    color: ({ severity }) => `${theme.palette.alerts[severity].iconColor} !important`,
    border: 'solid',
    borderRadius: '50%',
    height: '44px',
    width: '44px',
    display: 'flex',
    padding: '7px',
    justifyContent: 'center',
    background: ({ severity }) => theme.palette.alerts[severity].iconBackground,
    borderColor: 'transparent',

    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      marginBottom: 0
    }
  },
  messageWrapper: {
    color: ({ severity }) => theme.palette.alerts[severity].color,
    marginLeft: theme.spacing(2)
  }
}));

const Field = ({ severity, details }) => {
  const classes = useStyles({ severity });
  const { t } = useTranslation(['form']);
  const labelToDisplay = employeeFormMap.hasOwnProperty(details[0]) ? employeeFormMap[details[0]] : details[0];
  if (!details[1]) {
    return null;
  }
  return (
    <Alert
      severity={severity}
      key={uuid()}
      iconMapping={{ [severity]: fieldIcon(details[0]) }}
      classes={{
        root: classes.alert,
        icon: classes.icon,
        message: classes.message
      }}
    >
      <div className={classes.messageWrapper}>
        {t(`field.${labelToDisplay}`, { ns: 'form' })}: {details[1]?.suggestion}
      </div>
    </Alert>
  );
};

Field.propTypes = {
  severity: PropTypes.string,
  details: PropTypes.array
};

export default Field;
